import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Info } from "lucide-react";
import api from "@/lib/api";
import useSeo from "@/hooks/useSeo";
import { formatDate } from "@/lib/constants";

export default function Opinion() {
  const [items, setItems] = useState([]);
  useSeo({ title: "Opinión", description: "Columnas de opinión y análisis de columnistas e invitados de NEXODUM." });

  useEffect(() => { api.get("/articles?category=opinion&limit=40").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);

  return (
    <div data-testid="opinion-page" className="bg-nx-soft min-h-screen">
      <section className="bg-nx-dark text-white">
        <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
          <div className="flex items-center gap-3">
            <span className="w-2 h-10 rounded-sm bg-nx-blue" />
            <div>
              <p className="text-[11px] uppercase tracking-[0.3em] text-nx-blue">Análisis y reflexión</p>
              <h1 className="font-serif font-black text-4xl md:text-6xl tracking-tight italic">Opinión</h1>
            </div>
          </div>
        </div>
      </section>

      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-start gap-3 bg-white border border-gray-200 rounded-md p-4 text-sm text-gray-600" data-testid="opinion-disclaimer">
          <Info size={18} className="text-nx-blue shrink-0 mt-0.5" />
          <p>Las opiniones expresadas por columnistas e invitados son responsabilidad de sus autores y no necesariamente representan la posición editorial de NEXODUM.</p>
        </div>
      </div>

      <section className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {items.map((a) => (
            <Link key={a.id} to={`/opinion/${a.slug}`} data-testid={`opinion-col-${a.slug}`}
              className="group bg-white border border-gray-200 rounded-md p-6 md:p-8 hover:border-nx-blue transition-colors">
              <span className="text-[10px] font-bold tracking-[0.3em] uppercase text-nx-blue">Opinión</span>
              <h2 className="font-serif font-bold text-2xl md:text-3xl leading-tight mt-3 text-nx-dark group-hover:text-nx-blue transition-colors">{a.title}</h2>
              <p className="mt-3 text-gray-600 line-clamp-2">{a.subtitle}</p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-gray-100">
                {a.author_avatar && <img src={a.author_avatar} alt={a.author} className="w-12 h-12 rounded-full object-cover" />}
                <div>
                  <p className="font-bold text-nx-dark text-sm">{a.author}</p>
                  <p className="text-xs text-gray-500">{a.author_role}</p>
                  <p className="text-xs text-gray-400 mt-0.5">{formatDate(a.date)}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
